<template>
  <div class="management-navigation">
    <vertical-navigation
      title="Management"
      :links="links"/>
  </div>
</template>

<script>
import VerticalNavigation from '@/components/navigation/VerticalNavigation.vue'

export default {
  name: 'AccountListingsNavigation',
  components: {
    VerticalNavigation,
  },
  data() {
    return {
      links: [
        {
          type: 'subheading',
          name: 'Listings',
        },
        {
          type: 'link',
          name: 'Approval Queue',
          to: '/manage/review-listings',
        },
        {
          type: 'link',
          name: 'Purchase Requests',
          to: '/manage/purchases',
        },
        {
          type: 'link',
          name: 'Payments',
          to: '/manage/payments',
        },
        {
          type: 'subheading',
          name: 'Other',
        },
        {
          type: 'link',
          name: 'Users',
          to: '/manage/users/',
        },
      ],
    }
  },
}
</script>
